import { renderChips } from 'utils';
import { DataCellProps } from '../types';
import { Box } from '@mui/material';

export const TeamTagsCell = ({ team }: DataCellProps) => {
  const tagList = team.tags || [];
  return (
    <Box display={'flex'} justifyContent={'center'}>
      {renderChips(tagList, 2)}
    </Box>
  );
};
